import { Navigate, Route, Routes } from 'react-router-dom';
import { ADVERTISING_CAMPAIGNS_CREATE_LINK, ADVERTISING_CAMPAIGNS_MAIN_LINK, PLATFORM_MAIN_LINK } from '../../../assets/utils/constants';
import AdvertisingCampaignCreate from './AdvertisingCampaignCreate';
import AdvertisingCampaignDetail from './AdvertisingCampaignDetail';
import AdvertisingCampaignList from './AdvertisingCampaignList';
import './AdvertisingCampaigns.css';

function AdvertisingCampaigns() {
    return (
        <div className='advertising-campaigns'>
            <Routes>
                <Route index element={<AdvertisingCampaignList />} />
                <Route path={`${ADVERTISING_CAMPAIGNS_CREATE_LINK}`} element={<AdvertisingCampaignCreate />} />
                <Route path={`${ADVERTISING_CAMPAIGNS_CREATE_LINK}/:id`} element={<Navigate replace to={`${PLATFORM_MAIN_LINK}/${ADVERTISING_CAMPAIGNS_MAIN_LINK}`} />} />
                <Route path=':promotionId' element={<AdvertisingCampaignDetail />} />
            </Routes>
        </div>
    );
}

export default AdvertisingCampaigns;
